import { ConsumerEntityModel } from '../models';

const configConsumers: ConsumerEntityModel[] = [
	{
		source: 'Funda',
		paths: [
			{
				name: 'fundaoverwaardedesktop',
				links:
					{
						surplusInformation: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemeter&utm_campaign=701070000016sfrAAA',
						canIAffordThisHouse: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemeter_kidhb&utm_campaign=701070000016sfrAAA'
					}
			},
			{
				name: 'fundaoverwaardemobile',
				links:
					{
						surplusInformation: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemetermweb&utm_campaign=701070000016sfsAAA',
						canIAffordThisHouse: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemetermweb_kidhb&utm_campaign=7701070000016sfsAAA'
					}
			},
			{
				name: 'fundaoverwaardeapp',
				links:
					{
						surplusInformation: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemeterapp&utm_campaign=701070000016sg1AAA',
						canIAffordThisHouse: 'utm_source=funda&utm_medium=webvertising&utm_content=overwaardemeterapp_kidhb&utm_campaign=701070000016sg1AAA'
					}
			}
		]
	}
]

export { configConsumers };
